import React from 'react'
import PropTypes from 'prop-types'
import PlayerRow from '../../common/PlayerRow'

// One golfer in a picker list; `active` mirrors the keyboard highlight, as focus stays on the search.

const PlayerPickerOption = ({ player, onClick, disabled = false, id, active = false }) => (
  <button
    id={id}
    role={id ? 'option' : undefined}
    aria-selected={id ? active : undefined}
    tabIndex={id ? -1 : undefined}
    className={`gl-event-setup-slot-picker-item${active ? ' is-active' : ''}`}
    type="button"
    onClick={onClick}
    disabled={disabled}
    >
    <PlayerRow player={player}/>
  </button>
)

PlayerPickerOption.propTypes = {
  player: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  active: PropTypes.bool,
}

export default PlayerPickerOption
